export const rupiah = (n) => {
  if (n === null || n === undefined || isNaN(n)) return 'Rp0';
  const r = Math.round(n);
  const s = new Intl.NumberFormat('id-ID', { maximumFractionDigits: 0 }).format(Math.abs(r));
  return `${r < 0 ? '-' : ''}Rp${s}`;
};

export const num = (n, digits = 0) => {
  if (n === null || n === undefined || isNaN(n)) return '0';
  return new Intl.NumberFormat('id-ID', { maximumFractionDigits: digits }).format(n);
};

export const roundUp500 = (v) => {
  if (!v || v <= 0) return 0;
  return Math.ceil(v / 500) * 500;
};

export const formatTanggal = (iso) => {
  if (!iso) return '-';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatTanggalInput = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};
